module.exports = __webpack_public_path__ + "static/media/ghss.cf1ebfee.png";